import { jsx } from "panel";
import { delayedAttrRemove } from "panel/lib/component-utils/hook-helpers";
import { ListItemEl } from "common/components/list-item";
import { SvgIconEl } from "common/components/svg-icon";
import { UpsellPopupEl } from "common/widgets/upsell-popup";
import { DropMenuEl } from "common/components/drop-menu";
import { InputEl } from "common/components/input";
import { InputGroupEl } from "common/components/input-group";
import { ButtonBarEl } from "common/components/button-bar";
import { ConfirmEl } from "common/components/confirm";
import { THEME } from "common/components/confirm/types";
export function template() {
  const {
    activeBookmark,
    confirmDeleteBookmark,
    createMode,
    filterText,
    filteredBookmarks,
    open,
    saving,
    showUpsellModal
  } = this.state;
  const ListItem = (_ref) => {
    var _this$helpers$stringF;
    let {
      bookmark
    } = _ref;
    return /* @__PURE__ */ jsx(ListItemEl, { attrs: {
      active: activeBookmark && activeBookmark.id === bookmark.id
    }, on: {
      click: () => this.helpers.selectBookmark(bookmark),
      mouseover: () => this.helpers.activateBookmark(bookmark),
      mouseleave: () => this.helpers.activateBookmark(null)
    }, "data-sentry-element": "ListItemEl", "data-sentry-component": "ListItem", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-bookmark-row" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-bookmark-details" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-name", attrs: {
      title: bookmark.name
    } }, (_this$helpers$stringF = this.helpers.stringFilterMatches(bookmark.name, filterText)) === null || _this$helpers$stringF === void 0 ? void 0 : _this$helpers$stringF.map((token, pos) => pos % 2 === 1 ? /* @__PURE__ */ jsx("span", null, this.helpers.truncateMiddle(token, 40)) : /* @__PURE__ */ jsx("b", null, token))), /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-creator" }, bookmark.user)), this.attr("has-write-permissions") ? /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-delete-button", on: {
      click: (ev) => this.helpers.openConfirmDeleteDialog(ev, bookmark)
    } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "trashcan"
    } })) : null));
  };
  return /* @__PURE__ */ jsx("div", { sel: ".mp-bm-container", on: {
    scroll: this.helpers.stopPropagation
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, showUpsellModal ? /* @__PURE__ */ jsx(UpsellPopupEl, { hook: {
    remove: delayedAttrRemove("open", false)
  }, attrs: {
    open: true,
    feature: "bookmark-maximum"
  }, on: {
    change: this.helpers.closeUpsellModal
  } }) : null, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-btn", on: {
    click: this.helpers.toggleBookmarksMenu
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-btn-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "bookmarks"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("span", null, "Bookmarks")), /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu", attrs: {
    tabindex: 0
  } }, open ? /* @__PURE__ */ jsx(DropMenuEl, { hook: {
    remove: delayedAttrRemove("open", false)
  }, attrs: {
    open: true
  }, on: {
    change: this.helpers.handleDropMenuChange
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-container", attrs: {
    "slot-body": true
  } }, /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bm-menu-search", attrs: {
    icon: "search",
    placeholder: "Search bookmarks..."
  }, on: {
    change: this.helpers.stopPropagation,
    input: this.helpers.setFilterText
  } }), /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-list" }, (() => {
    const numBookmarkSections = Object.keys(filteredBookmarks).length;
    return numBookmarkSections === 0 ? /* @__PURE__ */ jsx(ListItemEl, { attrs: {
      static: true
    } }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-empty" }, "No bookmarks found, try creating a bookmark.")) : numBookmarkSections === 1 ? Object.values(filteredBookmarks)[0].map((bookmark) => /* @__PURE__ */ jsx(ListItem, { bookmark })) : (() => {
      let sectionIdx = 0;
      return filteredBookmarks.map((bookmarks, sectionName) => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ListItemEl, { attrs: {
        static: true
      } }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-section-header" }, sectionName)), bookmarks.map((bookmark) => /* @__PURE__ */ jsx(ListItem, { bookmark })), ++sectionIdx < numBookmarkSections ? /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-list-item-divider" }) : null));
    })();
  })()), this.attr("has-write-permissions") && !this.attr("hide-create") ? /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-add" }, !this.attr("create-disabled") && (createMode || saving) ? /* @__PURE__ */ jsx(InputGroupEl, { attrs: {
    autofocus: true,
    placeholder: "Name your bookmark",
    busy: saving
  }, on: {
    keydown: this.helpers.stopPropagation,
    change: this.helpers.stopPropagation,
    input: this.helpers.setName,
    submit: this.helpers.createBookmark
  } }) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonBarEl, { sel: ".mp-button-bar-secondary", attrs: {
    disabled: this.attr("create-disabled")
  }, on: {
    click: this.attr("over-free-limit") ? this.helpers.openUpsellModal : this.helpers.goToCreateMode
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-button-bar-text", class: {
    "mp-bm-menu-over-free-text": this.attr("over-free-limit")
  } }, "Create new bookmark")), this.attr("over-free-limit") ? /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-upsell-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "lightning-bolt"
  } })) : null)) : null)) : null), confirmDeleteBookmark ? /* @__PURE__ */ jsx(ConfirmEl, { hook: {
    remove: delayedAttrRemove("open", false)
  }, attrs: {
    theme: THEME.DELETE,
    closeable: true,
    open: true
  }, on: {
    change: this.helpers.handleConfirmModalChange,
    submit: this.helpers.handleConfirmSubmit
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-bm-menu-confirm-delete-container", attrs: {
    "slot-body": true
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-title" }, "Delete bookmark"), confirmDeleteBookmark.include_in_dashboard ? /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description" }, 'Are you sure you want to delete the bookmark named "', confirmDeleteBookmark.name, '"?', /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("br", null), "Deleting it will also remove it from all boards.") : /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description" }, 'Are you sure you want to delete the bookmark named "', confirmDeleteBookmark.name, '"?'))) : null);
}
